const directives = () => {};

export default directives;
